// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.participant-item {
  position: relative;
  padding: 16px;
  background: #080707;
  border-radius: 8px;
  cursor: pointer;
}
.participant-item:hover {
  background: var(--primary-color);
}
.participant-item__inner {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
}
@media (max-width: 767px) {
  .participant-item__inner {
    flex-wrap: wrap;
  }
}
.participant-item__wrapper {
  display: flex;
  align-items: center;
}
@media (max-width: 767px) {
  .participant-item__wrapper {
    flex-wrap: wrap;
  }
}
.participant-item__content {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.4s ease;
}
.participant-item__content-header {
  margin: 30px 0;
  font-size: 20px;
  color: #fff;
}
.participant-item__content-inner {
  position: relative;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 20px 35px;
}
.participant-item__content-wrapper {
  min-height: 0;
  transition: all 0.3s;
  visibility: hidden;
  overflow: hidden;
  opacity: 0;
}
.participant-item__content-item {
  width: calc(50% - 20px);
  padding: 16px;
  background: #131313;
  border-radius: 8px;
}
@media (max-width: 992px) {
  .participant-item__content-item {
    width: 100%;
  }
  .participant-item__content-item.participant-item__user-name {
    display: block;
  }
  .participant-item__content-item.participant-item__status {
    display: block;
  }
  .participant-item__content-item.participant-item__type {
    display: block;
  }
}
.participant-item__content-item span {
  color: #fff;
  font-weight: bold;
}
.participant-item__select {
  margin-right: 15px;
}
.participant-item__id {
  width: 3%;
  min-width: 60px;
}
.participant-item__avatar {
  width: 2%;
  min-width: 50px;
}
.participant-item__status {
  width: 5%;
  min-width: 140px;
}
@media (max-width: 992px) {
  .participant-item__status {
    display: none;
  }
}
.participant-item__ip {
  width: 5%;
  min-width: 150px;
}
@media (max-width: 992px) {
  .participant-item__ip {
    display: none;
    min-width: 250px;
    padding: 20px 0;
    align-items: center;
  }
}
.participant-item__date {
  width: 5%;
  min-width: 180px;
  padding-left: 20px;
}
@media (max-width: 992px) {
  .participant-item__date {
    min-width: 250px;
    padding: 20px 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
.participant-item__name {
  color: #f4f4f4;
  min-width: 150px;
  width: 25%;
}
@media (max-width: 1700px) {
  .participant-item__name {
    width: 15%;
  }
}
.participant-item__user-name {
  color: #f4f4f4;
  min-width: 150px;
  width: 15%;
}
@media (max-width: 1400px) {
  .participant-item__user-name {
    width: 10%;
    display: none;
  }
}
.participant-item__img {
  width: 50px;
}
.participant-item__controls {
  position: absolute;
  right: 15px;
  display: flex;
  justify-content: flex-end;
  min-width: 50px;
  width: 5%;
}
@media (max-width: 767px) {
  .participant-item__controls {
    align-items: center;
  }
}
.participant-item__controls a {
  display: inline-flex;
  transition: all 0.3s ease;
}
.participant-item__controls a svg {
  width: 25px;
  height: 15px;
}
.participant-item__controls a svg path {
  fill: #fff;
}
.participant-item__controls a:hover svg {
  width: 25px;
  height: 15px;
}
.participant-item__controls a:hover svg path {
  fill: #ff0000;
  stroke: #ff0000;
}
.participant-item__controls a:active {
  transform: scale(0.95);
}
.participant-item.active .participant-item__content {
  grid-template-rows: 1fr;
}
.participant-item.active .participant-item__content-wrapper {
  visibility: visible;
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/components/molecules/ParticipantItem/ParticipantItem.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAEA;EAEE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAFF;AAGE;EACE,gCCVG;ADSP;AAGE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AADJ;AAGI;EANF;IAOI,eAAA;EAAJ;AACF;AAEE;EACE,aAAA;EACA,mBAAA;AAAJ;AAEI;EAJF;IAKI,eAAA;EACJ;AACF;AACE;EACE,aAAA;EACA,uBAAA;EAEA,wCAAA;AAAJ;AACI;EACE,cAAA;EACA,eAAA;EACA,WAAA;AACN;AACI;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;AACN;AACI;EAEE,aAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;AAAN;AAEI;EACE,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AAAN;AACM;EALF;IAME,WAAA;EAEJ;EADM;IACE,cAAA;EAGR;EADM;IACE,cAAA;EAGR;EADM;IACE,cAAA;EAGR;AACF;AADM;EACE,WAAA;EACA,iBAAA;AAGR;AACE;EACE,kBAAA;AACJ;AACE;EACE,SAAA;EACA,eAAA;AACJ;AACE;EACE,SAAA;EACA,eAAA;AACJ;AACE;EACE,SAAA;EACA,gBAAA;AACJ;AAAI;EAHF;IAII,aAAA;EAGJ;AACF;AADE;EACE,SAAA;EACA,gBAAA;AAGJ;AAFI;EAHF;IAII,aAAA;IACA,gBAAA;IACA,eAAA;IAEA,mBAAA;EAIJ;AACF;AAFE;EACE,SAAA;EACA,gBAAA;EACA,kBAAA;AAIJ;AAHI;EAJF;IAKI,gBAAA;IACA,eAAA;IACA,aAAA;IACA,mBAAA;IACA,yBAAA;EAMJ;AACF;AAJE;EACE,cAAA;EAEA,gBAAA;EACA,UAAA;AAKJ;AAJI;EALF;IAMI,UAAA;EAOJ;AACF;AALE;EACE,cAAA;EAEA,gBAAA;EACA,UAAA;AAMJ;AALI;EALF;IAMI,UAAA;IACA,aAAA;EAQJ;AACF;AAHE;EACE,WAAA;AAKJ;AAHE;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,yBAAA;EACA,eAAA;EACA,SAAA;AAKJ;AAJI;EAPF;IAQI,mBAAA;EAOJ;AACF;AANI;EACE,oBAAA;EACD,yBAAA;AAQL;AAPM;EACE,WAAA;EACA,YAAA;AASR;AARQ;EACE,UAAA;AAUV;AANQ;EACE,WAAA;EACA,YAAA;AAQV;AAPU;EACE,aAAA;EACA,eAAA;AASZ;AALM;EACE,sBAAA;AAOR;AAFI;EACE,uBAAA;AAIN;AAHM;EACE,mBAAA;EACA,UAAA;AAKR","sourcesContent":["@import '../../../styles/_variables';\r\n\r\n.participant-item{\r\n  $self:&;\r\n  position: relative;\r\n  padding: 16px;\r\n  background: #080707;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  &:hover{\r\n    background: $main;\r\n  }\r\n  &__inner{\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    width: 100%;\r\n    //justify-content: space-between;\r\n    @media (max-width:767px){\r\n      flex-wrap: wrap;\r\n    }\r\n  }\r\n  &__wrapper{\r\n    display: flex;\r\n    align-items: center;\r\n    //justify-content: space-between;\r\n    @media (max-width:767px){\r\n      flex-wrap: wrap;\r\n    }\r\n  }\r\n  &__content{\r\n    display: grid;\r\n    grid-template-rows: 0fr;\r\n    //overflow: hidden;\r\n    transition: grid-template-rows 0.4s ease;\r\n    &-header{\r\n      margin: 30px 0;\r\n      font-size: 20px;\r\n      color:#fff;\r\n    }\r\n    &-inner{\r\n      position: relative;\r\n      width: 100%;\r\n      display: flex;\r\n      flex-wrap: wrap;\r\n      gap: 20px 35px;\r\n    }\r\n    &-wrapper{\r\n\r\n      min-height: 0;\r\n      transition:all 0.3s;\r\n      visibility: hidden;\r\n      overflow: hidden;\r\n      opacity: 0;\r\n    }\r\n    &-item{\r\n      width: calc(50% - 20px);\r\n      padding: 16px;\r\n      background: #131313;\r\n      border-radius: 8px;\r\n      @media (max-width:992px){\r\n      width: 100%;\r\n        &#{$self}__user-name{\r\n          display: block;\r\n        }\r\n        &#{$self}__status{\r\n          display: block;\r\n        }\r\n        &#{$self}__type {\r\n          display: block;\r\n        }\r\n      }\r\n      span{\r\n        color:#fff;\r\n        font-weight: bold;\r\n      }\r\n    }\r\n  }\r\n  &__select{\r\n    margin-right: 15px;\r\n  }\r\n  &__id{\r\n    width: 3%;\r\n    min-width: 60px;\r\n  }\r\n  &__avatar{\r\n    width: 2%;\r\n    min-width: 50px;\r\n  }\r\n  &__status{\r\n    width: 5%;\r\n    min-width: 140px;\r\n    @media (max-width:992px){\r\n      display: none;\r\n    }\r\n  }\r\n  &__ip{\r\n    width: 5%;\r\n    min-width: 150px;\r\n    @media (max-width:992px){\r\n      display: none;\r\n      min-width: 250px;\r\n      padding: 20px 0;\r\n  //    display: flex;\r\n      align-items: center;\r\n    }\r\n  }\r\n  &__date{\r\n    width: 5%;\r\n    min-width: 180px;\r\n    padding-left: 20px;\r\n    @media (max-width:992px){\r\n      min-width: 250px;\r\n      padding: 20px 0;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: flex-end;\r\n    }\r\n  }\r\n  &__name{\r\n    color:#f4f4f4;\r\n    //min-width: 30%;\r\n    min-width: 150px;\r\n    width: 25%;\r\n    @media (max-width:1700px){\r\n      width: 15%;\r\n    }\r\n  }\r\n  &__user-name{\r\n    color:#f4f4f4;\r\n    //min-width: 30%;\r\n    min-width: 150px;\r\n    width: 15%;\r\n    @media (max-width:1400px){\r\n      width: 10%;\r\n      display: none;\r\n    }\r\n    @media (max-width:767px){\r\n\r\n    }\r\n  }\r\n  &__img{\r\n    width: 50px;\r\n  }\r\n  &__controls{\r\n    position: absolute;\r\n    right: 15px;\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    min-width: 50px;\r\n    width: 5%;\r\n    @media (max-width:767px){\r\n      align-items: center;\r\n    }\r\n    a{\r\n      display: inline-flex;\r\n     transition: all 0.3s ease;\r\n      svg{\r\n        width:25px;\r\n        height:15px;\r\n        path{\r\n          fill: #fff\r\n        }\r\n      }\r\n      &:hover{\r\n        svg{\r\n          width:25px;\r\n          height:15px;\r\n          path{\r\n            fill: #ff0000;\r\n            stroke:#ff0000\r\n          }\r\n        }\r\n      }\r\n      &:active{\r\n        transform: scale(0.95);\r\n      }\r\n    }\r\n  }\r\n  &.active{\r\n    #{$self}__content{\r\n      grid-template-rows: 1fr;\r\n      &-wrapper{\r\n        visibility: visible;\r\n        opacity: 1;\r\n      }\r\n    }\r\n\r\n  }\r\n}","$main: var(--primary-color);\r\n$accent:  var(--accent-color);\r\n$additional: var(--additional-color);"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
